import { FunctionComponent } from 'react';
import { Head } from 'head/Head';
import Terms from 'routes/legal/Terms';

const TermsRoute: FunctionComponent<{}> = () => {
  return (
    <>
      <Head
        title="Tock - Terms"
        description="Tock terms of service"
        keywords="terms of service, terms, conditions"
      />

      <Terms />
    </>
  );
};

export default TermsRoute;
